import { lazy } from 'react';

export const LazyReleasesV2 = lazy(() => 
  import('@/pages/ReleasesV2').then(module => ({ default: module.ReleasesV2 }))
);
